module.exports = __webpack_public_path__ + "img/20191028172122360截图20191028162855384.0a1e6808.jpg";